export const scrollToTop = () => window.scrollTo(0, 0);

export const getBaseUrl = (organizationId: string) => `/dash/${organizationId}`;
